/* THE NATIVE CALCULATOR'S BEHAVIOUR (2026-09-15).

   Pairs with snippets/wk-calculator.liquid. Three jobs, nothing else:

     1. Show and hide the conditional sections exactly as Apippa did (display on
        the .element wrapper), because wk-product-page.js reads that to know
        which size branch is live.
     2. Preview the price from the generated table (#wk-price-table, a copy of
        the pricing service's data/price-table.json) into #priceTicker, which
        the qty bar, the stocking-dealer mirror and the retail portal all read.
        The rules are the contract's (docs/CONTRACT.md in the calculator repo);
        the SERVICE's number is the one charged, never this one.
     3. Add to cart: send the configuration (never a price) to the pricing
        service through Shopify's app proxy, then add the variant it created,
        retrying the cart add while Shopify indexes the new variant.

   theme.js's own add-to-cart click and the form's submit are stepped around for
   #calculator[data-wk-native] (a window-capture click listener runs before
   theme.js's document-capture one; the Apippa-era check inside theme.js is gone).
   Messages use the .errors.wk-form-msg element the theme already styles, since
   Apippa's base stylesheet hides a bare .errors while Apippa is installed. */
(function () {
  'use strict';

  var calc = document.getElementById('calculator');
  if (!calc || !calc.hasAttribute('data-wk-native')) return;

  var form = calc.closest('form') || document.querySelector('.product-single__form');
  var button = form && form.querySelector('.add-to-cart');
  var handle = calc.getAttribute('data-wk-handle');
  var isRug = calc.getAttribute('data-wk-rug') === 'true';

  var T = null;
  try {
    var tableEl = document.getElementById('wk-price-table');
    T = tableEl ? JSON.parse(tableEl.textContent) : null;
  } catch (e) { T = null; }
  var band = T && T.products ? T.products[handle] : null;
  var bandData = band && T.bands ? T.bands[band] : null;
  var SIZES = {};
  if (T && T.standard_sizes) {
    T.standard_sizes.forEach(function (s) { SIZES[s.code] = s; });
  }
  var LIMITS = (T && T.limits) || { width_ft_min: 1, width_ft_max: 13, length_ft_min: 1, length_ft_max: 40, inches_max: 11.5, inches_step: 0.5, quantity_max: 20 };
  var STEP = LIMITS.inches_step || 0.5;
  if (!bandData) {
    /* Not on the price table: the service would refuse it too. Say so once and
       leave the button disabled rather than let a form submit add the base
       variant at the per-square-foot rate. */
    calc.setAttribute('data-wk-unpriced', '1');
    if (window.console) console.warn('wk-calculator: ' + handle + ' is not on the price table');
    return;
  }

  /* ---------------------------------------------------------------- lookups */
  function el(name) { return calc.querySelector('.element[data-element="' + name + '"]'); }
  function checkedValue(name) {
    var i = calc.querySelector('.element[data-element="' + name + '"] input:checked');
    return i ? i.value : null;
  }
  function numberOf(name) {
    var i = calc.querySelector('.element[data-element="' + name + '"] input.numInput-cpc');
    var v = parseFloat(i && i.value);
    return isFinite(v) ? v : 0;
  }
  function selectOf(name) { return calc.querySelector('.element[data-element="' + name + '"] select'); }

  /* ------------------------------------------------------------------ state */
  function state() {
    var sizeMode = checkedValue('Choose Size') === 'Standard' ? 'standard' : 'custom';
    var shape = (isRug && checkedValue('Choose Shape') === 'Round') ? 'round' : 'rectangle';
    var border = (isRug && checkedValue('Choose Border') === 'Binding') ? 'Binding' : 'Serged to Match';
    var bindSel = selectOf('Custom Binding');
    var qtySel = selectOf('Quantity');
    var round = sizeMode === 'custom' && shape === 'round';
    return {
      product_handle: handle,
      size_mode: sizeMode,
      standard_size: sizeMode === 'standard' ? (checkedValue('Standard Stock Sizes') || null) : null,
      shape: sizeMode === 'standard' ? 'rectangle' : shape,
      width_ft: numberOf('Width Feet'),
      width_in: numberOf('Width Inches'),
      length_ft: round ? 0 : numberOf('Length Feet'),
      length_in: round ? 0 : numberOf('Length Inches'),
      border: border,
      binding: border === 'Binding' ? (bindSel ? bindSel.value : null) : null,
      pad: isRug && checkedValue('Choose Rug Pad') === 'Yes',
      treatment: isRug && checkedValue('Protective Treatment') === 'Yes',
      quantity: parseInt(qtySel ? qtySel.value : '1', 10) || 1,
      /* Contract 1.7: price and weight for ONE rug; the cart line carries the
         quantity. The add below still reads the answer's per_unit before
         trusting it, so an older service can never cause an N x N charge. */
      per_unit: true
    };
  }

  /* The customer-facing check the service repeats server-side. Returns a
     message, or null when the configuration is sendable. */
  function onStep(n) { return Math.abs(n / STEP - Math.round(n / STEP)) < 1e-9; }
  function validate(s) {
    var isInt = function (n) { return Math.floor(n) === n; };
    var inchesOk = function (n) { return n >= 0 && n <= LIMITS.inches_max && onStep(n); };
    if (s.size_mode === 'standard') {
      if (!s.standard_size || !SIZES[s.standard_size]) return 'Please choose a standard size.';
    } else {
      if (!isInt(s.width_ft) || s.width_ft < LIMITS.width_ft_min || s.width_ft > LIMITS.width_ft_max) {
        return 'Width must be between ' + LIMITS.width_ft_min + ' and ' + LIMITS.width_ft_max + ' feet.';
      }
      if (!inchesOk(s.width_in)) return 'Width inches must be between 0 and ' + LIMITS.inches_max + ', in half-inch steps.';
      if (s.width_ft === LIMITS.width_ft_max && s.width_in > 0) return 'The maximum width is ' + LIMITS.width_ft_max + ' feet, so at ' + LIMITS.width_ft_max + ' feet the inches must be 0.';
      if (s.shape !== 'round') {
        if (!isInt(s.length_ft) || s.length_ft < LIMITS.length_ft_min || s.length_ft > LIMITS.length_ft_max) {
          return 'Length must be between ' + LIMITS.length_ft_min + ' and ' + LIMITS.length_ft_max + ' feet.';
        }
        if (!inchesOk(s.length_in)) return 'Length inches must be between 0 and ' + LIMITS.inches_max + ', in half-inch steps.';
        if (s.length_ft === LIMITS.length_ft_max && s.length_in > 0) return 'The maximum length is ' + LIMITS.length_ft_max + ' feet, so at ' + LIMITS.length_ft_max + ' feet the inches must be 0.';
      }
    }
    if (s.border === 'Binding' && !s.binding) return 'Please choose a binding.';
    if (s.quantity < 1 || s.quantity > LIMITS.quantity_max) return 'Quantity must be between 1 and ' + LIMITS.quantity_max + '.';
    return null;
  }

  /* ---------------------------------------------------------------- pricing */
  function areaOf(s) {
    if (s.size_mode === 'standard') {
      var sz = SIZES[s.standard_size];
      return sz ? sz.area_sqft : 0;
    }
    var w = s.width_ft + s.width_in / 12;
    var l = s.shape === 'round' ? w : s.length_ft + s.length_in / 12;
    return w * l;
  }

  /* The per-rug price in whole dollars (contract 1.7 rounds down per rug), or
     null when the configuration cannot be priced. Mirrors docs/CONTRACT.md
     "Pricing rules": a round rug carries the surcharge, a pad on a round rug
     carries it again, both inside the unit; the cart multiplies by the line's
     quantity. */
  function unitOf(s) {
    var area = areaOf(s);
    var pad = s.pad ? area * (T.pad_rate_per_sqft || 0) : 0;
    var unit;
    if (s.size_mode === 'standard') {
      var total = bandData.trade_standard_total ? bandData.trade_standard_total[s.standard_size] : null;
      if (total == null) return null;
      unit = total + pad;
    } else {
      if (!(area > 0)) return null;
      var round = s.shape === 'round';
      var surcharge = round ? (T.round_surcharge_usd || 0) * (s.pad ? 2 : 1) : 0;
      unit = area * bandData.trade_rate_per_sqft + pad + surcharge;
    }
    return Math.floor(unit + 1e-9);
  }
  /* The total counts from the old number to the new, as Apippa's did and as
     the add-on notes still do (wk-product-page.js): nothing on this site
     changes in a single frame. Reduced motion, a hidden tab or no previous
     number get the plain swap. */
  var counting = false;
  function setTicker(dollars) {
    var ticker = document.getElementById('priceTicker');
    if (!ticker) return;
    var text = dollars == null ? '0' : String(dollars);
    ticker.setAttribute('data-origmoney', text);
    var prev = parseInt(ticker.textContent.replace(/[^0-9]/g, ''), 10);
    var still = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!isFinite(prev) || prev === dollars || still || document.hidden || counting) {
      if (ticker.textContent !== text) ticker.textContent = text;
      return;
    }
    counting = true;
    var t0 = performance.now(), DUR = 380;
    window.setTimeout(function () { counting = false; }, DUR + 250);
    (function tick(now) {
      var goal = parseInt(ticker.getAttribute('data-origmoney'), 10);
      if (!isFinite(goal)) { counting = false; return; }
      var p = Math.min(1, ((now || performance.now()) - t0) / DUR);
      var eased = 1 - Math.pow(1 - p, 3);
      var v = String(Math.round(prev + (goal - prev) * eased));
      if (ticker.textContent !== v) ticker.textContent = v;
      if (p < 1) requestAnimationFrame(tick); else { counting = false; if (ticker.textContent !== String(goal)) ticker.textContent = String(goal); }
    })(t0);
  }

  function render() {
    var s = state();
    var problem = validate(s);
    calc.setAttribute('data-wk-valid', problem ? '0' : '1');
    /* An entry that cannot be priced (a blank, a negative, a quarter inch) leaves
       the last valid price standing rather than printing $0 (Astra, 2026-09-16);
       the add explains the problem in words. Binding-only problems still price. */
    if (problem && !/binding/i.test(problem)) {
      calc.setAttribute('data-wk-price-cents', '');
      announce(null, null, s);
      return;
    }
    var unit = unitOf(s);
    var dollars = unit == null ? null : unit * s.quantity;
    calc.setAttribute('data-wk-price-cents', dollars == null ? '' : String(dollars * 100));
    setTicker(dollars);
    announce(unit, dollars, s);
  }
  /* THE PRICE EVENT (Phase 3a of the Apippa removal, 2026-09-30). Everything
     that mirrors the price (the stocking-dealer 70% figure, the retail
     portal's dealer total and quote lines) listens for this on document
     instead of watching the DOM and parsing the ticker's text. `cents` is the
     line total for compatibility; `unit_cents` x `quantity` says the same. */
  function announce(unitDollars, totalDollars, s) {
    try {
      document.dispatchEvent(new CustomEvent('wk:calculator:price', { detail: {
        cents: totalDollars == null ? null : totalDollars * 100,
        unit_cents: unitDollars == null ? null : unitDollars * 100,
        total_cents: totalDollars == null ? null : totalDollars * 100,
        quantity: s.quantity,
        state: s
      } }));
    } catch (e) { /* CustomEvent unsupported: nothing listens in that engine anyway */ }
  }

  /* ----------------------------------------------------------- conditionals */
  function show(name, on) {
    var e = el(name);
    if (!e) return;
    var want = on ? '' : 'none';
    if (e.style.display !== want) e.style.display = want;
  }
  function syncConditionals() {
    var s = state();
    var custom = s.size_mode === 'custom';
    show('Standard Stock Sizes', !custom);
    ['Choose Shape', 'Width Feet', 'Width Inches', 'Length Feet', 'Length Inches'].forEach(function (n) { show(n, custom); });
    show('Custom Binding', isRug && s.border === 'Binding');
  }

  /* 13' is the largest width and 40' the largest length, as a TOTAL: once the
     feet field sits at its maximum the inches go to 0 and stay there. Written
     only when they are not already 0, so nothing loops (input -> change -> here). */
  function clampInchesAtMax() {
    [['Width Feet', 'Width Inches', LIMITS.width_ft_max], ['Length Feet', 'Length Inches', LIMITS.length_ft_max]].forEach(function (pair) {
      var feet = calc.querySelector('.element[data-element="' + pair[0] + '"] input.numInput-cpc');
      var inches = calc.querySelector('.element[data-element="' + pair[1] + '"] input.numInput-cpc');
      if (!feet || !inches) return;
      if (parseFloat(feet.value) === pair[2] && parseFloat(inches.value) > 0) {
        inches.value = '0';
        inches.dispatchEvent(new Event('input', { bubbles: true }));
        inches.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }
  /* The pad's cards stop asking (custom.css .wk-asks) the moment one is chosen. */
  function settlePadAsk() {
    var e = isRug ? el('Choose Rug Pad') : null;
    if (e && e.classList.contains('wk-asks') && checkedValue('Choose Rug Pad') !== null) e.classList.remove('wk-asks');
  }
  function onChange() { clampInchesAtMax(); syncConditionals(); settlePadAsk(); render(); }
  calc.addEventListener('input', onChange);
  calc.addEventListener('change', onChange);
  /* The qty bar and the binding picker write to the selects and dispatch
     change through wkSet; both land here. A click on a card that has not
     changed a value yet still re-runs cheaply. */
  calc.addEventListener('click', function () { setTimeout(onChange, 0); });

  /* ------------------------------------------------------------- messaging */
  var MSG = {
    cartFail: 'We couldn’t add this rug to your cart. Please try again.',
    binding: 'Please choose your binding first: Cotton or Sunbrella, then Bound to Match or a color.',
    pad: 'Please choose whether to add a rug pad first: None, or Add rug pad.'
  };
  var messageTimer = null;
  function clearMessage() {
    if (!form) return;
    var old = form.querySelector('.errors.wk-form-msg');
    if (old) old.remove();
    if (messageTimer) { clearTimeout(messageTimer); messageTimer = null; }
  }
  /* An error in the form's own .errors dress, gone after 8s. */
  function message(text, kind, linkHtml) {
    if (!form) return null;
    clearMessage();
    var box = document.createElement('div');
    box.className = 'errors wk-form-msg';
    box.setAttribute('role', 'alert');
    box.textContent = text;
    if (linkHtml) {
      box.appendChild(document.createTextNode(' '));
      var span = document.createElement('span');
      span.innerHTML = linkHtml;
      box.appendChild(span);
    }
    var anchor = form.querySelector('#wk-qtybar') || form.querySelector('.payment-buttons') || button || form.firstChild;
    form.insertBefore(box, anchor);
    messageTimer = setTimeout(function () { if (box.parentNode) box.remove(); }, 8000);
    return box;
  }

  /* --------------------------------------------------------- button states */
  function label() { return button && button.querySelector('[data-add-to-cart-text]'); }
  /* THE WORKROOM (owner, 2026-09-16). While the pricing service works, the Add
     to cart button acts the rug out in three scenes (custom.css "THE WORKROOM"):
     a tape measure ticks in along its foot (Measuring, 0-1.6s), a blade crosses
     right to left and the halves part a hair (Cutting, 1.6-3.2s), then a cream
     thread is sewn around the edge under a mask (Serging, or Binding over a
     wider band when the shopper chose binding, from 3.2s) and closes the loop
     the moment the add lands (Added, with a soft wash). The thread never
     finishes on its own: it crawls ever slower toward the last stretch, so a
     slow add is still being sewn when it lands and the landing always closes
     the loop, over a beat sized to what is left. An add that lands during the
     measuring or cutting plays the remaining scenes at double speed (wk-wr-fast)
     instead of jumping, so the sequence always reads in order.
     The words sit on a split-flap label of eleven cells built here at boot
     beside the theme's own label (which stays as the accessible name and takes
     the same words): on every change each letter flips to blank in a
     left-to-right wave and the new word flips in a beat behind, so Cutting and
     Serging, which share their tail, still read as two words. Reduced motion
     skips the scenes and sets the words outright. */
  var SVG_NS = 'http://www.w3.org/2000/svg';
  var WR_CELLS = 11, WR_MEASURE = 1600, WR_CUT = 3200, WR_FAST = 800;
  var WR_PHASES = ['wk-wr-measure', 'wk-wr-cut', 'wk-wr-sew'];
  var wrStill = !!(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches);
  var wr = { built: false, timers: [], cells: [], text: 'Add to cart', edge: null, t0: 0, bind: false };

  function wrPad(text) {
    var pad = Math.max(0, Math.floor((WR_CELLS - text.length) / 2)), sp = '';
    for (var i = 0; i < WR_CELLS; i++) sp += ' ';
    return (sp.slice(0, pad) + text + sp).slice(0, WR_CELLS);
  }
  function wrEl(tag, cls, parent) {
    var e = document.createElement(tag);
    e.className = cls;
    parent.appendChild(e);
    return e;
  }
  function wrBuild() {
    if (wr.built || !button) return;
    var l = label();
    wr.text = (l && l.textContent.trim()) || wr.text;
    var frag = document.createDocumentFragment();
    wrEl('span', 'wk-wr-half wk-wr-half--top', frag);
    wrEl('span', 'wk-wr-half wk-wr-half--bottom', frag);
    var ticks = wrEl('span', 'wk-wr-ticks', frag), n = 60;
    for (var i = 0; i <= n; i++) {
      var t = wrEl('span', 'wk-wr-tick' + (i % 12 === 0 ? ' wk-wr-tick--ft' : ''), ticks);
      t.style.left = (i / n * 100) + '%';
      t.style.setProperty('--wk-in', (i / n * 1.35) + 's');
    }
    wrEl('span', 'wk-wr-blade', frag);
    var svg = document.createElementNS(SVG_NS, 'svg');
    svg.setAttribute('class', 'wk-wr-edge');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('preserveAspectRatio', 'none');
    var defs = document.createElementNS(SVG_NS, 'defs');
    var mask = document.createElementNS(SVG_NS, 'mask');
    mask.setAttribute('id', 'wk-wr-mask');
    var reveal = document.createElementNS(SVG_NS, 'path');
    reveal.setAttribute('class', 'wk-wr-reveal');
    mask.appendChild(reveal); defs.appendChild(mask); svg.appendChild(defs);
    var g = document.createElementNS(SVG_NS, 'g');
    g.setAttribute('mask', 'url(#wk-wr-mask)');
    var band = document.createElementNS(SVG_NS, 'path');
    band.setAttribute('class', 'wk-wr-band');
    var thread = document.createElementNS(SVG_NS, 'path');
    thread.setAttribute('class', 'wk-wr-thread');
    g.appendChild(band); g.appendChild(thread); svg.appendChild(g);
    [reveal, band, thread].forEach(function (p) {
      p.setAttribute('pathLength', '100');
      p.setAttribute('vector-effect', 'non-scaling-stroke');
    });
    wr.edge = { svg: svg, reveal: reveal, band: band, thread: thread };
    frag.appendChild(svg);
    var lab = wrEl('span', 'wk-wr-label', frag);
    lab.setAttribute('aria-hidden', 'true');
    var start = wrPad(wr.text.toUpperCase());
    for (var k = 0; k < WR_CELLS; k++) {
      var cell = wrEl('span', 'wk-wr-cell', lab);
      var ch = wrEl('span', 'wk-wr-ch', cell);
      ch.textContent = start[k];
      cell.__t = [];
      wr.cells.push(cell);
    }
    button.insertBefore(frag, button.firstChild);
    if (l) l.setAttribute('aria-live', 'polite');
    button.classList.add('wk-wr');
    wr.built = true;
  }
  /* The edge is drawn to the button's real size: squared top corners, the
     house 12px at the foot, the thread 2px in from the edge, the band 4px. */
  function wrSize() {
    if (!wr.edge) return;
    var r = button.getBoundingClientRect();
    var w = Math.max(40, Math.round(r.width)), h = Math.max(30, Math.round(r.height));
    var e = wr.edge;
    e.svg.setAttribute('viewBox', '0 0 ' + w + ' ' + h);
    var line = 'M2 2 H' + (w - 2) + ' V' + (h - 14) + ' Q' + (w - 2) + ' ' + (h - 2) + ' ' + (w - 14) + ' ' + (h - 2) +
      ' H14 Q2 ' + (h - 2) + ' 2 ' + (h - 14) + ' Z';
    var inner = 'M4 4 H' + (w - 4) + ' V' + (h - 15) + ' Q' + (w - 4) + ' ' + (h - 4) + ' ' + (w - 15) + ' ' + (h - 4) +
      ' H15 Q4 ' + (h - 4) + ' 4 ' + (h - 15) + ' Z';
    e.reveal.setAttribute('d', line);
    e.thread.setAttribute('d', line);
    e.band.setAttribute('d', inner);
  }
  function wrFlip(cell, target, delay) {
    var ch = cell.firstChild;
    cell.__t.push(setTimeout(function () { cell.classList.remove('wk-wr-flip'); void cell.offsetWidth; cell.classList.add('wk-wr-flip'); }, delay));
    cell.__t.push(setTimeout(function () { ch.textContent = target; }, delay + 80));
    cell.__t.push(setTimeout(function () { cell.classList.remove('wk-wr-flip'); ch.textContent = target; }, delay + 220));
  }
  function wrWord(text) {
    var l = label();
    if (l) l.textContent = text;
    if (!wr.built) return;
    var padded = wrPad(text.toUpperCase());
    wr.cells.forEach(function (cell, i) {
      var ch = cell.firstChild, old = ch.textContent, target = padded[i];
      cell.__t.forEach(clearTimeout); cell.__t = [];
      cell.classList.remove('wk-wr-flip');
      if (wrStill || (old === ' ' && target === ' ')) { ch.textContent = target; return; }
      if (old !== ' ') wrFlip(cell, ' ', i * 40);
      if (target !== ' ') wrFlip(cell, target, i * 40 + 260);
    });
  }
  function wrPhase(name) {
    WR_PHASES.forEach(function (p) { button.classList.remove(p); });
    if (name) button.classList.add(name);
  }
  function wrClearTimers() {
    wr.timers.forEach(clearTimeout); wr.timers = [];
  }
  function wrStart(binding) {
    wrBuild();
    wrSize();
    wrClearTimers();
    wr.t0 = Date.now();
    wr.bind = !!binding;
    button.classList.remove('wk-added', 'wk-wr-fast');
    button.classList.toggle('wk-wr-bind', !!binding);
    wrPhase(wrStill ? null : 'wk-wr-measure');
    wrWord('Measuring…');
    wr.timers.push(setTimeout(function () { wrPhase(wrStill ? null : 'wk-wr-cut'); wrWord('Cutting…'); }, WR_MEASURE));
    wr.timers.push(setTimeout(function () { wrPhase(wrStill ? null : 'wk-wr-sew'); wrWord(binding ? 'Binding…' : 'Serging…'); }, WR_CUT));
  }
  /* Lands the add. Returns the ms until Added is on the button: 0 when the
     sewing is already under way, else the fast-forward through what is left. */
  function wrLand() {
    wrClearTimers();
    var elapsed = Date.now() - wr.t0, steps = [];
    if (!wrStill) {
      if (elapsed < WR_MEASURE) steps.push(['wk-wr-cut', 'Cutting…']);
      if (elapsed < WR_CUT) steps.push(['wk-wr-sew', wr.bind ? 'Binding…' : 'Serging…']);
    }
    if (!steps.length) { wrFinish(); return 0; }
    button.classList.add('wk-wr-fast');
    steps.forEach(function (step, i) {
      var go = function () { wrPhase(step[0]); wrWord(step[1]); };
      if (i === 0) go(); else wr.timers.push(setTimeout(go, i * WR_FAST));
    });
    wr.timers.push(setTimeout(wrFinish, steps.length * WR_FAST));
    return steps.length * WR_FAST;
  }
  /* The thread closes from wherever the crawl left it, over .25s plus up to
     .6s for the distance left, so a nearly-done edge finishes with a touch
     and an early one gets a visible sweep. The inline offset pins the start
     of the transition to the animated value before the animation is removed. */
  function wrFinish() {
    var rv = wr.edge && wr.edge.reveal, from = 0;
    if (rv && !wrStill) {
      /* read before the phase class goes: with it goes the animation and the value */
      from = parseFloat(getComputedStyle(rv).strokeDashoffset) || 0;
      rv.style.strokeDashoffset = from;
      rv.style.transitionDuration = (0.25 + Math.min(1, from / 100) * 0.6).toFixed(2) + 's';
    }
    wrPhase(null);
    button.classList.add('wk-added');
    if (rv && !wrStill) { void rv.getBoundingClientRect(); rv.style.strokeDashoffset = ''; }
    wrWord('Added ✓');
  }
  function wrReset() {
    wrClearTimers();
    wrPhase(null);
    button.classList.remove('wk-added', 'wk-wr-bind', 'wk-wr-fast');
    if (wr.edge) { wr.edge.reveal.style.strokeDashoffset = ''; wr.edge.reveal.style.transitionDuration = ''; }
    wrWord(wr.text);
  }
  function begin() {
    if (!button) return;
    button.classList.add('btn--adding', 'wk-adding');
    button.disabled = true;
    wrStart(isRug && checkedValue('Choose Border') === 'Binding');
  }
  function end() {
    if (!button) return;
    button.classList.remove('btn--adding', 'wk-adding');
    button.disabled = false;
    if (!button.classList.contains('btn--added')) wrReset();
  }
  function showAdded() {
    if (!button) return 0;
    button.classList.remove('btn--adding', 'wk-adding');
    button.classList.add('btn--added');
    return wrLand();
  }
  /* The cart API accepts the new variant a beat before the storefront that
     renders the cart page knows its price and image; arriving in that beat
     shows the line as "Confirming" until wk-cart-settle catches up (owner saw
     it 2026-09-16). So after Added lands, the page waits, up to 8s, until
     /cart.js reports the line with a price and an image, then goes to the
     cart; if Shopify is slower than that it goes anyway and the cart page's
     own settle script takes over. */
  function lineSettled(line) {
    if (!line || !line.key) return Promise.resolve(true);
    return fetch('/cart.js?t=' + Date.now(), { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var it = null;
        for (var i = 0; i < cart.items.length; i++) if (cart.items[i].key === line.key) { it = cart.items[i]; break; }
        if (!it) return true;
        var img = it.image || (it.featured_image && it.featured_image.url);
        return !!img && (it.price > 0 || it.final_price > 0 || it.original_price > 0);
      })
      .catch(function () { return false; });
  }
  /* With the theme's cart set to Drawer, Added rebuilds and opens the drawer
     and the button returns to rest; with Page it leaves for the cart page. */
  function drawerCart() {
    return !!(window.theme && theme.settings && theme.settings.cartType === 'drawer' && document.getElementById('CartDrawer'));
  }
  function openDrawer() {
    document.dispatchEvent(new CustomEvent('cart:build'));
    document.dispatchEvent(new CustomEvent('cart:open'));
    setTimeout(function () { button.classList.remove('btn--added'); end(); busy = false; }, 1200);
  }
  function confirmAndGo(line) {
    clearMessage();
    var wait = showAdded();
    /* The label needs ~0.9s to flip Added in; leave it in view before the cart. */
    var minAt = Date.now() + wait + 1100, deadline = Date.now() + 8000;
    var go = drawerCart() ? openDrawer : function () { window.location.href = '/cart'; };
    var check = function () {
      lineSettled(line).then(function (ok) {
        if (ok || Date.now() >= deadline) { setTimeout(go, Math.max(0, minAt - Date.now())); return; }
        setTimeout(check, 600);
      });
    };
    check();
  }

  /* gt-01, carried over from theme.js: Binding chosen means the shopper
     clicked a material, the match card or a colour (wk-product-page.js sets
     window.__wkBindChosen). Fails open when the picker is not built. */
  function bindingChoiceMissing() {
    try {
      if (!isRug || checkedValue('Choose Border') !== 'Binding') return false;
      var e = el('Custom Binding');
      if (!e || !e.querySelector('select.calc-prop') || !e.querySelector('.wk-bindpick')) return false;
      return window.__wkBindChosen !== true;
    } catch (err) { return false; }
  }

  /* THE RUG PAD IS CHOSEN, NEVER ASSUMED (owner, 2026-10-07). Neither card is
     checked at boot (snippets/wk-calculator.liquid), the price previews without
     a pad until one is picked, and the add waits for the choice: a message, the
     pair asking in clay (.wk-asks) and the section brought into view. Fails
     open when the section is not rendered (the pad's own page has none). */
  function padChoiceMissing() {
    try {
      if (!isRug) return false;
      var e = el('Choose Rug Pad');
      if (!e || !e.querySelector('input[type="radio"]')) return false;
      return checkedValue('Choose Rug Pad') === null;
    } catch (err) { return false; }
  }

  /* ------------------------------------------------------------ the add */
  var busy = false;

  function fetchJson(url, init) {
    return fetch(url, init).then(function (r) {
      return r.json().catch(function () { return null; }).then(function (json) {
        return { ok: r.ok, status: r.status, json: json };
      });
    });
  }

  /* Shopify indexes a new variant within a second or two; until then
     /cart/add.js answers 422. Retry that and nothing else (docs/THEME-INTEGRATION.md 3). */
  function addToCartWithRetry(line) {
    var started = Date.now();
    return new Promise(function (resolve, reject) {
      (function attempt() {
        fetchJson('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(line)
        }).then(function (res) {
          if (res.ok) { resolve(res.json); return; }
          if (res.status === 422 && Date.now() - started < 10000) { setTimeout(attempt, 500); return; }
          reject({ code: 'UNAVAILABLE', message: MSG.cartFail });
        }).catch(function () { reject({ code: 'UNAVAILABLE', message: MSG.cartFail }); });
      })();
    });
  }

  function showError(err) {
    var code = (err && err.code) || 'UNAVAILABLE';
    var text = (err && err.message) || MSG.cartFail;
    var link = null;
    if (code === 'NOT_LOGGED_IN') {
      link = '<a href="/customer_authentication/login?return_to=' + encodeURIComponent(location.pathname) + '">Log in</a>';
    } else if (code === 'NOT_TRADE') {
      link = '<a href="/pages/trade-signup">Apply for a trade account</a>';
    }
    message(text, 'error', link);
    if (code === 'RATE_LIMITED') {
      /* Locked for a minute, then free again on its own. */
      busy = true; begin();
      setTimeout(function () { busy = false; end(); }, 60000);
    }
  }

  function addToCart() {
    if (busy) return;
    /* If anything ever swaps #calculator after boot (Apippa's embed did, seen live
       2026-09-16; kept as a guard), this state would be the defaults, not what
       the shopper set. Refuse rather than add the wrong rug. */
    if (document.getElementById('calculator') !== calc || !document.contains(calc)) {
      message('This page needs a reload before adding to cart. Please reload and try again.', 'error');
      try { console.error('wk-calculator: #calculator was replaced after boot'); } catch (e) {}
      return;
    }
    if (bindingChoiceMissing()) {
      message(MSG.binding, 'error');
      if (typeof window.__wkRevealBinding === 'function') window.__wkRevealBinding();
      return;
    }
    if (padChoiceMissing()) {
      message(MSG.pad, 'error');
      var padEl = el('Choose Rug Pad');
      if (padEl) {
        padEl.classList.add('wk-asks');
        /* Focus lands on the pair for the keyboard and the screen reader; the
           scroll is the page's own (wk-product-page.js), never the browser's. */
        var padFirst = padEl.querySelector('input[type="radio"]');
        if (padFirst) { try { padFirst.focus({ preventScroll: true }); } catch (e) { padFirst.focus(); } }
      }
      if (typeof window.__wkRevealRugPad === 'function') window.__wkRevealRugPad();
      return;
    }
    var s = state();
    var problem = validate(s);
    if (problem) { message(problem, 'error'); return; }
    /* PREVIEW ONLY: on 127.0.0.1 nobody can be signed in, so the service would
       refuse every add. The add is acted out instead so the motion can be
       reviewed on the local preview: it lands after five seconds, or after
       ?wk-demo-land=<ms> to see an early or late landing. Every check above
       runs first, so the preview refuses exactly what live refuses. */
    if (location.hostname === '127.0.0.1') {
      var landAt = parseInt((location.search.match(/[?&]wk-demo-land=(\d+)/) || [])[1], 10) || 5000;
      busy = true; begin();
      setTimeout(function () {
        var wait = showAdded();
        if (drawerCart()) { setTimeout(openDrawer, wait + 1100); return; }
        setTimeout(function () { button.classList.remove('btn--added'); end(); busy = false; }, wait + 2200);
      }, landAt);
      return;
    }

    busy = true;
    begin();
    /* The button's own "Adding..." state is the only feedback while the service
       works (owner, 2026-09-16: no status line under the form). Errors still speak. */
    clearMessage();

    fetchJson('/apps/pricing/variant', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(s)
    }).then(function (res) {
      if (!res.ok || !res.json || !res.json.variant_id) {
        var e = (res.json && res.json.error) || {};
        throw { code: e.code || 'UNAVAILABLE', message: e.message || MSG.cartFail };
      }
      /* The line's quantity comes from the ANSWER: per_unit true means the
         variant is for one rug and the line carries the count; anything else
         means the service baked the quantity into the variant and the line
         must stay at 1 (contract 1.7). */
      var lineQty = (res.json.per_unit === true && res.json.quantity > 0) ? res.json.quantity : 1;
      return addToCartWithRetry({ id: res.json.variant_id, quantity: lineQty, properties: res.json.properties });
    }).then(function (line) {
      confirmAndGo(line);
    }).catch(function (err) {
      busy = false;
      end();
      showError(err && err.code ? err : { code: 'UNAVAILABLE', message: MSG.cartFail });
    });
  }

  /* Before theme.js's document-capture takeover (window is earlier on the
     capture path), and before the form's own submit handler. The default
     action - a native form post carrying the BASE variant id - must never run. */
  window.addEventListener('click', function (ev) {
    var b = ev.target && ev.target.closest && ev.target.closest('.product-single__form .add-to-cart');
    if (!b || !form || !form.contains(b)) return;
    ev.preventDefault();
    ev.stopImmediatePropagation();
    addToCart();
  }, true);
  document.addEventListener('submit', function (ev) {
    if (!form || ev.target !== form) return;
    ev.preventDefault();
    ev.stopImmediatePropagation();
    addToCart();
  }, true);

  /* ------------------------------------------------------------------ boot */
  syncConditionals();
  render();
  wrBuild();
  if (button && button.hasAttribute('data-wk-native-wait')) {
    button.removeAttribute('data-wk-native-wait');
    button.disabled = false;
  }
  calc.setAttribute('data-wk-ready', '1');
})();
